import SVG from './SVG'
import * as T from './types'

// default position pointing to the right
const FlaredArrowShort = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox={props.viewBox || '0 0 15 15'}
    d="M7.00195 0.5L5.7682 1.73375L10.6507 6.625H0.00195312V8.375H10.6507L5.7682 13.2663L7.00195 14.5L14.002 7.5L7.00195 0.5Z"
  />
)

export default FlaredArrowShort
